export interface OptionOrder {
  id: number;
  title: string;
  subtitle?: string;
  price?: number;
  max?: number;
  min?: number;
  subOptions?: [OptionOrder];
  values: [OptionOrder];
  selectedValues: { [id: string]: string | number | boolean };
}

export interface ParsedOption {
  label: string;
  optionLabel: string;
}

export enum GourmetRegistrationSteps {
  Estimate = 0,
  CustomerInformation = 1,
  ChooseMembership = 2,
  Payment = 3,
  Confirmation = 4,
}

export enum GourmetResumeRegistrationSteps {
  PullupCustomerInfo = 0,
  Estimate = 1,
  CustomerInformation = 2,
  ChooseMembership = 3,
  Payment = 4,
  Confirmation = 5,
}

export enum GourmetRateTarget {
  Store = 1,
  Driver = 2,
}

export enum GourmetVendor {
  dd = 'DoorDash',
  ue = 'UberEats',
}

export enum MailDeliverability {
  Deliverable = 'deliverable',
  DeliverableUnnecessaryUnit = 'deliverable_unnecessary_unit',
  DeliverableIncorrectUnit = 'deliverable_incorrect_unit',
  DeliverableMissingUnit = 'deliverable_missing_unit',
  Undeliverable = 'undeliverable',
}

export enum DeliveryOrderStatus {
  Placed = 'placed',
  Preparing = 'preparing',
  Collecting = 'collecting',
  Transit = 'transit',
  Delivering = 'delivering',
  Complete = 'complete',
  Canceled = 'canceled',
  Error = 'error',
}
